module.exports = __webpack_public_path__ + "images/emoji/hotel.a7a5f5dbdf725f50bd37.png";